import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

import { SaveAccessoryRequestModelSchema } from '../schemas/SaveAccessoryRequestModel';

// No PathParameters

// No QueryParameters

export const RequestBodySchema = z.lazy(() => SaveAccessoryRequestModelSchema);
export type RequestBody = z.infer<typeof RequestBodySchema>;

const ResponseDataSchema = z.string();
export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export async function callApi(input: {
	requestBody: RequestBody;
}): Promise<Optional<ResponseData>> {
	const url: string = SERVICEBASEURL.BACKEND + `/Accessory`;
	return (await axios.post(url, input.requestBody).toOptionalFiltered(validator)).map(
		(x) => x.data
	);
}
